/*
 * @Description 组件 IndexCenter 布局
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-page-center start -->
	<div class="index-page-center">
		
		<!-- 组件 定位监控 -->
        <IndLocation />
		
		<!-- 组件 各类设备 -->
        <!--<IndTyDevice />-->
        
		<!-- 组件 现场人员 -->
        <!--<IndSiteUser />-->
		
        <!-- 组件 视频联动 -->
        <!--<IndVideoLinkage />-->
        
        <!-- 组件 各类报警 -->
        <IndCBAlarm />
        
	</div>
	<!-- index-page-center end -->
</template>

/* JS */
<script>
	// 组件 定位监控
	import IndLocation from '@/components_index/IndexItems/IndLocation';
	// 组件 现场人员
	// import IndSiteUser from '@/components_index/IndexItems/IndSiteUser';
	// 组件 各类设备
	// import IndTyDevice from '@/components_index/IndexItems/IndTyDevice';
	// 组件 视频联动
	// import IndVideoLinkage from '@/components_index/IndexItems/IndVideoLinkage';
	// 组件 各类报警
	import IndCBAlarm from '@/components_index/IndexItems/IndCBAlarm';
	
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndexCenter",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 定位监控
        	IndLocation,
        	
        	// 组件 各类设备
        	// IndTyDevice,
        	// 组件 现场人员
        	// IndSiteUser,
        	// 组件 视频联动
        	//IndVideoLinkage,
        	
        	// 组件 各类报警
        	IndCBAlarm,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>




// WEBPACK FOOTER //
// src/components_index/IndexPage/IndexCenter.vue